import React, { useState } from "react";
import {
  Form,
  Input,
  Card,
  Button,
  Select,
  Typography,
  Space,
  Tooltip,
  DatePicker,
  Col,
  Row,
  InputNumber,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import dayjs from "dayjs";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
const { Title, Paragraph } = Typography;
const { Option } = Select;

const InvestmentDetails = ({
  formData,
  minInvestment,
  onFinish,
  form,
  prodTemplate,
  maturityDate,
}) => {
  // React.useEffect(() => {
  //   form.setFieldValue("settlementDate", dayjs());
  // }, []);
  console.log(form.getFieldsValue());
  return (
    <div className="form-section">
      <h2 style={{ margin: 0, fontSize: "24px" }}>Investment Details</h2>
      <p style={{ marginTop: "5px", color: "#6b7280" }}>
        Add description text to note for users
      </p>

      <Form onFinish={onFinish} layout="vertical" form={form}>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Face value cannot be empty",
                },
                // {
                //   validator: (_, value) => {
                //     if (!value) {
                //       return Promise.reject(new Error(`Face value cannot be empty`));
                //     }
                //     if (value < minInvestment) {
                //       return Promise.reject(new Error(`Minimum investment amount is ₦${minInvestment}`));
                //     }
                //     return Promise.resolve();
                //   },
                // },
              ]}
              label={
                <Space>
                  Face Value
                  <Tooltip title="Face Value">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"faceValue"}
            >
              <InputNumber
                formatter={(value) =>
                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                placeholder="1000"
                style={{ height: "44px", width: "100%" }}
                prefix="₦"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Discount Rate (%)
                  <Tooltip title="Discount Rate(%)">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"discountRate"}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                placeholder="9.25"
                style={{ height: "44px" }}
                suffix="%"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Purchase Price
                  <Tooltip title="Purchase Price">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"purchasePrice"}
              rules={[
                // {
                //   required: true,
                //   message: "Face value cannot be empty",
                // },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.reject(
                        new Error(`Purchase price cannot be empty`)
                      );
                    }
                    if (value < minInvestment) {
                      return Promise.reject(
                        new Error(
                          `Purchase price cannot be lesser than ₦${minInvestment}`
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber
                className="of-bold-disable-input"
                formatter={(value) =>
                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                disabled
                placeholder="10000"
                style={{ height: "44px", width: "100%" }}
                prefix="₦"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Yield (% p.a.)
                  <Tooltip title="Yield">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"yieldPercentage"}
            >
              <InputNumber
                className="of-bold-disable-input"
                disabled
                placeholder="9.25"
                style={{ height: "44px", width: "100%" }}
                suffix="%"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Interest Type
                  <Tooltip title="Intrest Type">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"interestType"}
            >
              <Select
                className="custom-input read-only-select"
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                disabled
                options={prodTemplate.interestTypes}
                showSearch
                placeholder="Select interest type"
                optionFilterProp="children"
                style={{ height: "44px" }}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Maturity Value
                  <Tooltip title="Maturity Value">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"maturityValue"}
            >
              <InputNumber
                className="of-bold-disable-input custom-input"
                formatter={(value) =>
                  value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                disabled
                placeholder="1000000000"
                style={{ height: "44px", width: "100%" }}
                prefix="₦"
              />
            </Form.Item>
          </Col>

          <Col span={24} style={{ padding: "0px 8px" }}>
            <div style={{ display: "flex", gap: "20px" }}>
              <Form.Item
                label="Settlement Date"
                name={"settlementDate"}
                style={{ flex: 1 }}
              >
                <DatePicker
                  // size="large"
                  disabled
                  style={{ marginBottom: 0, width: "100%" }}
                  placeholder="DD/MM/YYYY"
                  suffixIcon={<CalendarIcon color="#667085" width={20} />}
                  className="bond-date-picker custom-input read-only-select"
                />
              </Form.Item>

              <Form.Item
                label="Value Date"
                name={"valueDate"}
                style={{ flex: 1, fontSize: "14px" }}
              >
                <DatePicker
                  disabled
                  // size="large"
                  style={{ marginBottom: 0, width: "100%" }}
                  placeholder="DD/MM/YYYY"
                  suffixIcon={<CalendarIcon color="#667085" width={20} />}
                  className="bond-date-picker custom-input read-only-select"
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default InvestmentDetails;
